"use client"

import { useEffect } from "react"

import { initSellerReferralCapture } from "@/lib/seller-referral/client"

export function SellerReferralBootstrap() {
  useEffect(() => {
    initSellerReferralCapture()
  }, [])

  return null
}
